export const SET_SITE_NAME = "SET_SITE_NAME";